



































import {Component, Vue} from 'vue-property-decorator'
import {Getter} from 'vuex-class'
import {InventoryItem, Service} from '@/store/types'

@Component({})
export default class TaskSurvey extends Vue {
  @Getter('inventory') public inventory!: InventoryItem[]
  @Getter('totalVolume') public totalVolume!: number
  @Getter('services') public services!: Service[]
}
